import { Link } from "react-router-dom";
import { XCircle, Sparkles } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel" className="min-h-screen flex items-center justify-center rose-grain p-6">
      <div className="card-luxe p-10 max-w-lg w-full text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-6">
          <Sparkles className="text-[var(--brand-primary)]" size={24}/>
          <span className="font-heading text-xl">Valeriia Nail Academy</span>
        </Link>
        <XCircle className="mx-auto text-[var(--text-muted)] mb-4" size={64}/>
        <h1 className="font-heading text-4xl mb-3">Pago cancelado</h1>
        <p className="text-[var(--text-muted)] mb-8">No se ha realizado ningún cargo. Puedes intentarlo de nuevo cuando quieras.</p>
        <Link to="/" data-testid="cancel-back" className="btn-brand">Volver a la página</Link>
      </div>
    </div>
  );
}
